<template>
    <el-drawer
        :append-to-body="true"
        :destroy-on-close="true"
        :modal="false"
        :size="isMobile ? '80%' : '40%'"
        :visible.sync="communityDrawer"
        custom-class="Order-Detail-Drawer"
        direction="rtl"
    >
        <div v-loading="loading" v-if="JSON.stringify(orderData) !== '{}'" class="Container">
            <div class="Top">
                <div class="T-Left">
                    <span>{{ orderData.resourceInfo.nameCn || orderData.resourceInfo.nameEn }}</span>
                    <span v-if="orderData.resourceInfo.nameCn">{{orderData.resourceInfo.nameEn }}</span>
                </div>
                <div class="T-Right">
                    <i class="el-icon-close" @click="communityDrawer = false"></i>
                </div>
            </div>
            <!-- 头部 -->
            <div class="Header">
                <div class="Resource-Info">
                    <div class="Images">
                        <el-carousel :interval="5000" height="180px" indicator-position="outside">
                            <el-carousel-item>
                                <img
                                    :src="orderData.resourceInfo.imageUrl || 'https://media.onyx-hospitality.com/-/media/project/amari/common/property/bangkok/hotel-photos/stay/club_one-bedroom_executive-suite/club_one-bedroom_executive-suite.jpg?rev=-1'"
                                    alt="资源图片" class="Carousel-Image">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <h2 class="Resource-Name">
                        <span>{{ orderData.resourceInfo.nameCn || orderData.resourceInfo.nameEn }}</span>
                        <span v-if="orderData.resourceInfo.nameCn" class="En-Name">{{
                                orderData.resourceInfo.nameEn
                            }}</span>
                    </h2>
                    <div v-if=" orderData.resourceInfo.addressCn" class="location-info">
                        <i class="el-icon-location"></i>
                        {{ orderData.resourceInfo.cityNameCn || orderData.resourceInfo.cityName }} ·
                        {{ orderData.resourceInfo.addressCn || orderData.resourceInfo.address }}
                    </div>
                </div>
                <i class="el-icon-close Close-Icon" @click="communityDrawer = false"></i>
            </div>
            <!-- 主体内容 -->
            <div  class="Main-Content scroll-area">
                <!-- 商品信息区块 -->
                <div class="Info-Card">
                    <h3 class="Card-Title">商品明细</h3>
                    <div v-for="(item, index) in orderData.orderListResult.orderListDetailResultList"
                         :key="index" class="Product-Item">
                        <div class="Product-Header">
                            <span class="Product-Name">{{ item.productNameCn || item.productName }}</span>
                            <span class="Product-En">{{ item.productNameEn }}</span>
                        </div>
                        <el-row :gutter="20" class="Detail-Row">
                            <el-col>
                                <div class="Detail-Item">
                                    <label>使用日期：</label>
                                    <span v-if="orderData.orderListResult.state === 0">{{
                                            item.startTime.replace(/\./g, "-")
                                        }} 至 {{ addOneDay(item.endTime) }}</span>
                                    <span v-else-if="item.startTime === item.endTime">{{ item.startTime }}</span>
                                    <span v-else>{{ item.startTime }} 至 {{ item.endTime }}</span>
                                </div>
                                <div class="Detail-Item">
                                    <label>取消数量：</label>
                                    <span>{{ item.cancelNumber || 0 }}</span>
                                </div>
                                <div class="Detail-Item">
                                    <label>实际数量：</label>
                                    <span>{{ item.number }}</span>
                                </div>
                                <div class="Detail-Item">
                                    <label>使用单位：</label>
                                    <span>{{ item.priceCompany }}/{{ item.useTime }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="Price-Section">
                            <div class="Price-Line">
                                <span class="Currency">{{ item.currency }}</span>
                                <span class="Amount">{{ item.price }}</span>
                                <span class="Unit">× {{ item.number }}</span>
                                <span class="Unit"> × {{
                                        days(item.startTime, item.endTime, orderData.orderListResult.state.state) + 1
                                    }}{{ item.useTime }}</span>
                            </div>
                            <div v-if="item.currency !== '￥'" class="Rate-Line">
                                <span>汇率：1{{ item.currency }} ≈ {{ item.rate }}CNY</span>
                            </div>
                            <div class="Total-Line">
                                小计：{{ (item.price * (days(item.startTime, item.endTime, orderData.orderListResult.state.state) + 1) * item.rate * item.number).toFixed(2) }}元
                            </div>
                        </div>
                    </div>
                    <!-- 总计 -->
                    <div class="Grand-Total">
                        <span class="Label">订单总额：</span>
                        <span class="Amount">
                            {{ totalAmount }}元
                        </span>
                    </div>
                </div>
                <!-- 取消备注区块 -->
                <div v-if="orderData.cgResultList && orderData.cgResultList.length > 0" class="Info-Card">
                    <h3 class="Card-Title">资源取消政策</h3>
                    <div v-for="(item, index) in orderData.cgResultList" :key="index" class="cancel-remark-item">
                        <div class="remark-header">
                            <div class="remark-title">
                                <span class="remark-name">{{ item.nameCn }}</span>
                                <span v-if="item.nameEn" class="remark-en-name">{{ item.nameEn }}</span>
                                <span class="remark-time">{{ dateFormatHm(item.createTime) }}</span>
                            </div>
                            <div v-if="item.selected" class="remark-status">已确认</div>
                        </div>
                        <div class="remark-content">
                            <p v-for="(remark, rIndex) in item.cancelRemark" :key="rIndex">{{ remark }}</p>
                        </div>
                    </div>
                </div>
                <!-- 取消政策区块 -->
                <div v-if="modifyOrderCancelResult" class="Info-Card">
                    <h3 class="Card-Title">价格政策</h3>
                    <div v-if="orderData.orderListResult.truncationResult.statusResultList.some(v => v.statusName === 'FAILED_AND_REFUNDED')"
                         class="refund-amount">
                        退款金额：{{ modifyOrderCancelResult.refundableTotalAmount }}元
                    </div>
                    <el-collapse accordion>
                        <el-collapse-item
                            v-for="(item,index) in modifyOrderCancelResult.modifyOrderCancelDetailResultList"
                            v-if="item.productName !== '城市税'"
                            :key="index"
                            :title="item.productName">
                            <div class="policy-content">
                                <div v-html="item.cancellationPolicyDescription"></div>
                                <div v-for="(group,gIndex) in item.stockInfo" :key="gIndex">
                                    <h4>{{ group.name }}</h4>
                                    <div v-for="(info,iIndex) in group.value" :key="iIndex" class="policy-item">
                                        <span class="label">{{ info.name }}</span>
                                        <span class="value">{{ info.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <!-- 状态进度条 -->
                <div class="Status-Horizontal">
                    <el-steps :active="activeStatusIndex" align-center>
                        <el-step
                            v-for="(status, index) in orderData.orderListResult.truncationResult.statusResultList"
                            :key="index"
                            :status="status.highlight ? 'process' : 'wait'"
                            :title="status.statusText"
                        ></el-step>
                    </el-steps>
                </div>
                <!-- 操作记录 -->
                <div class="Info-Card">
                    <h3 class="Card-Title">操作记录</h3>
                    <el-timeline>
                        <el-timeline-item
                            v-for="(log, index) in sortedLogs"
                            :key="index"
                            :color="themeColor"
                            :timestamp="log.createTime"
                            placement="top"
                        >
                            <div
                                :class="{ 'first-log': index === 0 }"
                                class="Log-Card"
                                v-html="log.remark"
                            ></div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
    </el-drawer>
</template>
<script>
import OrderApi from '@/components/Api/order'
import {addOneDay, dateFormatHm, days} from "../../../../../assets/utils/unit";

export default {
    data() {
        return {
            loading: false,
            communityDrawer: false,
            orderData: {},
            isMobile: window.innerWidth < 768,
            themeColor: '#CB582E'
        }
    },
    computed: {
        modifyOrderCancelResult() {
            return this.orderData.modifyOrderCancelResult || {};
        },
        sortedLogs() {
            return this.orderData.orderListResult?.truncationResult?.opLogResults?.slice().sort((a, b) => {
                return new Date(b.createTime) - new Date(a.createTime);
            }) || [];
        },
        activeStatusIndex() {
            return (this.orderData.orderListResult?.truncationResult?.statusResultList?.findIndex(
                status => status.highlight
            ) || 0) + 1;
        },
        totalAmount() {
            return (this.orderData.orderListResult?.orderListDetailResultList?.reduce(
                (sum, item) => sum + Number(item.price || 0) * (this.days(item.startTime, item.endTime) + 1) * item.rate * item.number, 0) || 0).toFixed(2)
        }
    },
    methods: {
        dateFormatHm,
        days,
        addOneDay,
        open(id) {
            this.communityDrawer = true
            this.getOrderDetails(id)
        },
        formatTime(timestamp) {
            return new Date(timestamp).toLocaleString();
        },
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        close() {
            this.communityDrawer = false
        },
        getOrderDetails(id) {
            this.loading = true
            new OrderApi('order').orderDetail(id).then(response => {
                if (response.status === 200) {
                    this.orderData = response.data;
                    this.loading = false
                } else {
                    this.$message.error(response.statusText)
                }
            }).catch(error => {
                this.$message.error('加载失败!')
                this.loading = false
            })
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>
<style lang="scss" scoped>
::v-deep .Order-Detail-Drawer .el-drawer__header {
    display: none;
}

.Top {
    background: #fbfbfb;
    height: 60px;
    border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .T-Left {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;

        > span:nth-child(1) {
            font-size: 16px;
            color: #333;
            font-weight: 700;
        }

        > span:nth-child(2) {
            font-size: 12px;
            color: #333;
            font-weight: 700;
        }
    }

    .T-Right {
        width: 60px;
        height: 60px;
        border-left: 1px solid #ddd;

        > i {
            font-size: 25px;
            font-weight: 700;
            display: flex;
            justify-content: center;
            position: relative;
            top: 50%;
            transform: translateY(-50%);

            &:hover {
                cursor: pointer;
            }
        }
    }
}

$theme-color: #CB582E;
.Order-Detail-Drawer {
    .Container {
        display: flex;
        flex-direction: column;
        height: 100vh;
    }

    .Header {
        position: relative;
        padding: 16px;
        background: #fff;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

        .Resource-Info {
            .Images {
                margin-bottom: 16px;
                border-radius: 8px;
                overflow: hidden;

                .Carousel-Image {
                    width: 100%;
                    height: 180px;
                    object-fit: cover;
                }
            }

            .Resource-Name {
                margin: 0 0 16px;
                font-size: 20px;
                color: #303133;

                .En-Name {
                    display: block;
                    font-size: 14px;
                    color: #909399;
                    margin-top: 4px;
                }
            }

            .location-info {
                padding: 12px 0;
                color: #606266;
                font-size: 14px;

                i {
                    color: $theme-color;
                    margin-right: 6px;
                }
            }
        }

        .Close-Icon {
            position: absolute;
            top: 24px;
            right: 24px;
            font-size: 24px;
            cursor: pointer;
            color: #909399;
            transition: color 0.3s;

            &:hover {
                color: #666;
            }
        }
    }

    .Main-Content {
        flex: 1;
        padding: 16px;
        overflow-y: auto;

        .Info-Card {
            background: #fff;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 16px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

            .Card-Title {
                margin: 0 0 16px;
                font-size: 16px;
                color: #303133;
                padding-bottom: 8px;
                border-bottom: 1px solid #ebeef5;
            }

            /* 商品明细样式 */
            .Product-Item {
                border: 1px solid #eee;
                border-radius: 8px;
                padding: 16px;
                margin-bottom: 16px;
                background: #fff;

                .Product-Header {
                    margin-bottom: 12px;
                    padding-bottom: 12px;
                    border-bottom: 1px solid #eee;

                    .Product-Name {
                        font-size: 16px;
                        color: #333;
                        font-weight: 600;
                    }

                    .Product-En {
                        display: block;
                        font-size: 12px;
                        color: #888;
                        margin-top: 4px;
                    }
                }

                .Detail-Row {
                    margin: 12px 0;

                    .Detail-Item {
                        margin: 8px 0;
                        font-size: 13px;

                        label {
                            color: #666;
                            display: inline-block;
                            width: 80px;
                            text-align: right;
                            margin-right: 8px;
                        }

                        span {
                            color: #333;
                        }
                    }
                }

                .Price-Section {
                    background: #f8f8f8;
                    border-radius: 6px;
                    padding: 12px;
                    margin-top: 12px;

                    .Price-Line {
                        font-size: 15px;
                        margin-bottom: 8px;

                        .Currency {
                            color: $theme-color;
                            font-weight: 500;
                        }

                        .Amount {
                            color: $theme-color;
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0 4px;
                        }

                        .Unit {
                            color: #666;
                        }
                    }

                    .Rate-Line {
                        font-size: 12px;
                        color: #888;
                        margin-bottom: 8px;
                    }

                    .Total-Line {
                        font-size: 14px;
                        font-weight: 500;
                    }
                }
            }

            .Grand-Total {
                margin-top: 20px;
                padding-top: 16px;
                border-top: 2px solid #eee;
                text-align: right;

                .Label {
                    font-size: 14px;
                    color: #666;
                }

                .Amount {
                    color: $theme-color;
                    font-size: 20px;
                    font-weight: 700;
                    margin-left: 8px;
                }
            }

            /* 取消政策样式 */
            .policy-content {
                padding: 10px;
                background: #f8f9fa;

                h4 {
                    color: #303133;
                    margin: 12px 0 8px;
                    font-size: 14px;
                }

                .policy-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 6px 0;
                    font-size: 13px;

                    .label {
                        color: #909399;
                        min-width: 100px;
                    }

                    .value {
                        color: #606266;
                        flex: 1;
                    }
                }
            }

            .refund-amount {
                color: $theme-color;
                background: #fdf6ec;
                padding: 10px;
                border-radius: 4px;
                margin-bottom: 12px;
                font-weight: bold;
            }
        }

        /* 操作记录样式 */
        .Log-Card {
            padding: 12px;
            background: #f8f9fa;
            border-left: 3px solid $theme-color;
            border-radius: 4px;
            position: relative;

            &.first-log {
                font-weight: 600;
                background: #f0faff;

                &::after {
                    content: '最新';
                    position: absolute;
                    right: 8px;
                    top: 8px;
                    background: $theme-color;
                    color: white;
                    padding: 2px 6px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }
        }

        /* 取消备注样式 */
        .cancel-remark-item {
            border: 1px solid #eee;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 16px;
            background: #fff;

            .remark-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
                padding-bottom: 12px;
                border-bottom: 1px solid #eee;

                .remark-title {
                    .remark-name {
                        font-size: 16px;
                        color: #333;
                        font-weight: 600;
                    }

                    .remark-en-name {
                        display: block;
                        font-size: 12px;
                        color: #888;
                        margin-top: 4px;
                    }
                }

                .remark-status {
                    background: $theme-color;
                    color: white;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }

            .remark-time {
                font-size: 12px;
                color: #909399;
                margin-left: 8px;
            }

            .remark-content {
                background: #f8f8f8;
                border-radius: 6px;
                padding: 12px;

                p {
                    margin: 4px 0;
                    white-space: pre-line;
                }
            }
        }
    }

    /* 状态步骤条样式 */
    .Status-Horizontal {
        background: #fff;
        padding: 20px;
        margin-bottom: 16px;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

        ::v-deep .el-steps {
            &__title {
                font-size: 13px !important;

                &[aria-current] {
                    color: $theme-color !important;
                }
            }

            &__head {
                &.is-process {
                    background-color: $theme-color;
                    border-color: $theme-color;
                }
            }

            &__line {
                background-color: #ebeef5;
            }
        }
    }
}
</style>